var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import React, { useCallback, useMemo, useState } from 'react';
import _ from 'lodash';
import { observer } from 'mobx-react';
import Grid from '../grid/GridComponent';
import useTheme from '../../../themes/hooks/UseTheme';
import SectionMetadata from './models/SectionMetadata';
import StackLayout from '../stackLayout/StackLayoutComponent';
import useActiveThemeVariation from '../../../themes/hooks/UseActiveThemeVariation';
import GridSectionHeader from './components/gridSectionHeader/GridSectionHeader';
import StickyGridSectionHeaderMetadata from './models/StickyGridSectionHeaderMetadata';
import StickyGridSectionHeader from './components/stickyGridSectionHeader/StickyGridSectionHeader';
var SectionGridComponent = function (props) {
    var _a;
    var sections = props.sections, columnCount = props.columnCount, emptyRenderer = props.emptyRenderer;
    var _b = __read(useState(StickyGridSectionHeaderMetadata.create()), 1), stickyGridSectionHeaderMetadata = _b[0];
    var theme = useTheme();
    var activeThemeVariation = useActiveThemeVariation(props, function (x) { return x.layoutThemes.sectionGrid; });
    var sectionHeight = useMemo(function () { var _a; return theme.resolveNumericFactor((_a = activeThemeVariation.sectionHeader) === null || _a === void 0 ? void 0 : _a.height); }, [(_a = activeThemeVariation.sectionHeader) === null || _a === void 0 ? void 0 : _a.height]);
    var totalItemCount = _.sumBy(sections, function (x) { return x.itemsCount; });
    var actualColumnCount = useMemo(function () { return columnCount ? theme.resolveResponsiveValue(columnCount) : 1; }, [columnCount]);
    var sectionMetadata = useMemo(function () {
        var e_1, _a;
        var sectionMetadata = [];
        var headlineRowIndex = 0;
        var latestSectionIndex = undefined;
        try {
            for (var sections_1 = __values(sections), sections_1_1 = sections_1.next(); !sections_1_1.done; sections_1_1 = sections_1.next()) {
                var section = sections_1_1.value;
                // ignore empty sections
                if (!section.itemsCount) {
                    continue;
                }
                var rows = Math.ceil(section.itemsCount / actualColumnCount);
                var isFirstSection = sectionMetadata.length === 0;
                var endRowIndex = headlineRowIndex + rows;
                if (isFirstSection && sections.length > 1) {
                    // ToDo: the following line is needed for multiple sections only???
                    endRowIndex--;
                }
                latestSectionIndex = sections.indexOf(section);
                sectionMetadata.push(new SectionMetadata(headlineRowIndex, endRowIndex, section, isFirstSection));
                headlineRowIndex = endRowIndex + 1;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (sections_1_1 && !sections_1_1.done && (_a = sections_1.return)) _a.call(sections_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (latestSectionIndex !== undefined && stickyGridSectionHeaderMetadata.stickySectionIndex === undefined) {
            stickyGridSectionHeaderMetadata.setStickySectionIndex(latestSectionIndex);
        }
        return sectionMetadata;
    }, [totalItemCount, actualColumnCount]);
    var rowHeightResolver = useCallback(function (rowIndex, columnWidth) {
        var activeSection = sectionMetadata.find(function (x) { return x.isActiveSection(rowIndex); });
        if (!activeSection) {
            return 0;
        }
        if (!activeSection.isFirstSection && activeSection.headlineRowIndex === rowIndex) {
            return sectionHeight || 0;
        }
        return activeSection.resolveRowHeight(rowIndex, columnWidth, theme);
    }, [sectionMetadata]);
    var lastSection = _.last(sectionMetadata);
    var rowCount = lastSection ? lastSection.endRowIndex + 1 : 0;
    // skip the first one, because it is the sticky one
    var headlineRowIndies = sectionMetadata.map(function (x) { return x.headlineRowIndex; }).filter(function (x) { return x > 0; });
    console.log('rowCount', rowCount);
    console.log('actualColumnCount', actualColumnCount);
    return (React.createElement(StackLayout, { stretch: true },
        React.createElement(StickyGridSectionHeader, { stickyGridSectionHeaderMetadata: stickyGridSectionHeaderMetadata, sections: sections, sectionHeaderTheme: activeThemeVariation.sectionHeader || {} }),
        React.createElement(Grid, { virtualized: true, columnCount: actualColumnCount, rowCount: rowCount, singleColumnRowIndices: headlineRowIndies, itemRenderer: function (props) {
                var section = sectionMetadata.find(function (x) { return x.isActiveSection(props.rowIndex); });
                if (!section) {
                    return null;
                }
                if (!section.isFirstSection && section.headlineRowIndex === props.rowIndex) {
                    // ToDo: maybe move in observer to prevent not rendering!
                    if (sectionMetadata.indexOf(section) === stickyGridSectionHeaderMetadata.stickySectionIndex) {
                        console.log('section SKIPPED', section);
                        return null;
                    }
                    return (React.createElement(GridSectionHeader, { section: section.section, sectionHeaderTheme: activeThemeVariation.sectionHeader || {} }));
                }
                var itemIndex = section.getItemIndex(props.rowIndex, props.columnIndex, actualColumnCount);
                if (itemIndex >= section.section.itemsCount) {
                    console.log('ITEM skipped', itemIndex);
                    return null;
                }
                return section.section.itemRenderer(itemIndex);
            }, emptyRenderer: emptyRenderer, rowHeight: rowHeightResolver, onItemsRendered: function (_a) {
                var visibleRowStartIndex = _a.visibleRowStartIndex;
                var activeSectionMetadata = sectionMetadata.find(function (x) { return x.isActiveSection(visibleRowStartIndex); });
                if (!activeSectionMetadata) {
                    return;
                }
                stickyGridSectionHeaderMetadata.setStickySectionIndex(sections.indexOf(activeSectionMetadata.section));
            } })));
};
export default observer(SectionGridComponent);
//# sourceMappingURL=SectionGridComponent.js.map